import React from 'react';
import { useAppContext } from '../../context/AppContext';

const EditorControls = () => {
  const { setDslInput, isLiveMode, setIsLiveMode, showToast } = useAppContext();

  const clearEditor = () => {
    setDslInput('');
    showToast('Workspace cleared', 'info');
  };

  const toggleBackendMode = () => {
    setIsLiveMode(!isLiveMode);
    showToast(`Switched to ${!isLiveMode ? 'Live' : 'Mock'} backend mode`, 'info');
  };

  return (
    <div className="editor-controls">
      <div className="control-buttons-left">
        <button 
          className={`mode-toggle ${isLiveMode ? 'live-mode' : 'mock-mode'}`}
          onClick={toggleBackendMode}
        >
          {isLiveMode ? '💡 Live Backend' : '🔴 Mock Backend'}
        </button>
        <button className="clear-button" onClick={clearEditor}>Clear Workspace</button>
      </div>
    </div>
  );
};

export default EditorControls;